import classNames from 'classnames'
import { InheritanceResource, type MenuOption } from '@opallabs/concepts'
import { Color, getResourceGlyph } from '@opallabs/gem'
import { useTheme } from '@opallabs/hooks'
import { Icon, useVariantStyle, SingleSelect } from '@opallabs/lapidary'
import * as styles from '../CollaboratorListItem/styles'

const permissionOptions: Array<MenuOption<boolean>> = [
  { value: false, label: "Don't Inherit Access" },
  { value: true, label: 'Inherit Access' },
]

type ResourceItemProps = {
  className?: string
  onChangeInheritance: (inheritsMembership: boolean) => void
  readOnly?: boolean
  resource: InheritanceResource
  showPermissions?: boolean
}

export const ResourceListItem: React.FC<ResourceItemProps> = ({
  className,
  onChangeInheritance,
  readOnly = false,
  resource: { resourceType, title, memberCount, inheritsMembership },
  showPermissions = true,
}) => {
  const theme = useTheme()
  const variantStyle = useVariantStyle('ghost')

  return (
    <li
      className={classNames('collaborator-list-item', className)}
      css={styles.container}
    >
      <div className="collaborator-user-details" css={styles.details}>
        <Icon
          glyph={getResourceGlyph(theme, resourceType, 'outlined')}
          width={24}
          height={24}
        />
        <span>{title}</span>
        <span css={{ color: Color[theme].Text.Gray }}>{memberCount}</span>
      </div>
      {showPermissions && (
        <div className="collaborator-user-permissions">
          <SingleSelect.Root
            options={permissionOptions}
            initialSelection={permissionOptions[inheritsMembership ? 1 : 0]}
            onChange={(selectedItem) => {
              if (selectedItem) {
                onChangeInheritance(selectedItem.value)
              }
            }}
          >
            <SingleSelect.Body>
              <SingleSelect.Trigger
                css={variantStyle[theme]}
                disabled={readOnly}
              >
                <SingleSelect.TriggerText
                  css={{ color: Color[theme].Text.Gray }}
                />
              </SingleSelect.Trigger>
              <SingleSelect.Menu
                css={{ maxInlineSize: '155px !important' }}
                menuWidth={155}
              >
                <SingleSelect.MenuItems />
              </SingleSelect.Menu>
            </SingleSelect.Body>
          </SingleSelect.Root>
        </div>
      )}
    </li>
  )
}
